export const themeClassPrimary = document.body.dataset.primaryTheme || "theme-teal";
export const themeClassSecondary = document.body.dataset.secondaryTheme || "theme-purple";